import { render, staticRenderFns } from "./DashParents.vue?vue&type=template&id=3b3a936d"
import script from "./DashParents.vue?vue&type=script&lang=js"
export * from "./DashParents.vue?vue&type=script&lang=js"
import style0 from "./DashParents.vue?vue&type=style&index=0&id=3b3a936d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports